export const ROLE_TYPES = {
  SUPER_ADMIN: 'SuperAdmin',
  HS_ADMIN: 'HsAdmin',
  DOCTOR: 'Doctor',
  PATIENT: 'Patient',
  CA: 'CA',
  FAMILY_MEMBER: 'FamilyMember',
  MANAGER: 'Manager',
  TRAINER: 'Trainer',
  INTERNAL_TRAINER: 'InternalTrainer',
  MHS: 'MHS',
  SYSTEM_ADMIN: 'SystemAdmin',
  TELE_FIT_ADMIN: 'TeleFITAdmin',
  TELE_FIT_SUPER_ADMIN: 'TeleFITSuperAdmin',
  TELE_FIT_STUDIO: 'TeleFITStudio',
  CSO: 'CSO',
  SWABBER: 'Swabber',
  COUNSELLOR: 'Counsellor',
  COUNSELLOR_EXECUTIVE: 'CounsellorExecutive',
  CLINIC_MANAGER: 'ClinicManager',
  CLINIC_ADMIN: 'ClinicAdmin',
};

export const ROLES_CONSULT_TYPE_PAYMENT = [
  ROLE_TYPES.SYSTEM_ADMIN,
  ROLE_TYPES.CA,
  ROLE_TYPES.SUPER_ADMIN,
  ROLE_TYPES.SWABBER,
  ROLE_TYPES.HS_ADMIN,
];

export const ROLES_NAMES_SPECIAL = [
  ROLE_TYPES.DOCTOR,
  ROLE_TYPES.SWABBER,
  ROLE_TYPES.COUNSELLOR,
];

export const ROLES_CANNOT_REVERT_CONSULT = [
  ROLE_TYPES.CA,
  ROLE_TYPES.SWABBER,
  ROLE_TYPES.DOCTOR,
];

export const ROLES_CAN_REVERT_CONSULT = [
  ROLE_TYPES.SYSTEM_ADMIN,
  ROLE_TYPES.SUPER_ADMIN,
  ROLE_TYPES.CA,
  ROLE_TYPES.CLINIC_MANAGER,
  ROLE_TYPES.CLINIC_ADMIN,
];

/**
 * Roles allowed to open the manual lab-number popup while a screening is still
 * In Progress. Everyone else only gets the auto-generate path until the
 * screening is Completed.
 */
export const ROLES_CAN_EDIT_LAB_NUMBER_IN_PROGRESS = [
  ROLE_TYPES.SYSTEM_ADMIN,
  ROLE_TYPES.SUPER_ADMIN,
];
